import React from 'react';
import {FormattedMessage} from 'react-intl';

// CSS
import './index.scss';

/**
 * [GeneralAdmissionBanner description]
 */
const GeneralAdmissionBanner = () => {
  return (
    <div className="GeneralAdmissionBanner__container">
      <div className="GeneralAdmissionBanner__header">
        <FormattedMessage id="GeneralAdmissionBanner.header" defaultMessage="General Admission event" />
      </div>
      <div className="GeneralAdmissionBanner__text">
        <FormattedMessage
          id="GeneralAdmissionBanner.text"
          defaultMessage="All tickets give you access to any available seating or standing areas. There is no assigned seating."
        />
      </div>
    </div>
  );
};

export default GeneralAdmissionBanner;
